import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import SEOContentGrid from './components/SEOContentGrid';
import TrustSection from './components/TrustSection';
import TestimonialSection from './components/TestimonialSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.cfd';

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: 'OOPBUY Spreadsheet',
          url: siteUrl,
          logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg',
          description: 'Unabhängige Informationsplattform für OOPBUY Spreadsheet in Deutschland',
          sameAs: [
            'https://kaspreadsheet.com',
          ],
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'OOPBUY Spreadsheet Deutschland',
          description: 'Die umfassendste deutsche Informationsquelle für OOPBUY Spreadsheet',
          inLanguage: 'de-DE',
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteUrl}/search?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@type': 'FAQPage',
          '@id': `${siteUrl}/#faq`,
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Was ist OOPBUY Spreadsheet?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'OOPBUY Spreadsheet ist eine innovative Shopping-Plattform, die es Nutzern ermöglicht, Produkte von internationalen Marktplätzen wie Taobao, Weidian und 1688 über eine übersichtliche Tabellenkalkulation zu entdecken und zu bestellen.',
              },
            },
            {
              '@type': 'Question',
              name: 'Welche Kategorien bietet OOPBUY Spreadsheet?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'OOPBUY Spreadsheet bietet 14 Kategorien: Schuhe, Hoodies/Sweater, T-Shirts, Jacken, Hosen/Shorts, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und Sonstiges.',
              },
            },
            {
              '@type': 'Question',
              name: 'Ist OOPBUY Spreadsheet für den deutschen Markt geeignet?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Ja, OOPBUY Spreadsheet ist speziell für den deutschen Markt optimiert mit deutschsprachiger Oberfläche, Support und integrierten Versand- und Zollinformationen für Deutschland.',
              },
            },
          ],
        },
      ],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <CTASection />
      <SEOContentGrid />
      <TrustSection />
      <TestimonialSection />
      <Footer />
    </main>
  );
}